import { useMemo } from "react";
import {
  CHAT_WITH_OPERATOR_CLOSED_BECAUSE_OF_TIME_TEXT,
  CHAT_WITH_OPERATOR_NEED_TO_SEND_PRACTICE_TEXT,
  EMPTY_STRING,
} from "../../../../../../../constants/commonStrings";
import { useChatWithOperatorState } from "../../../../../../hooks/useChatWithOperatorState";

export function useChatWithOperatorTooltip() {
  const { isChatEnabled, isPracticeSentToOperator, hasTwoMonthsPassedSincePracticeOpened } = useChatWithOperatorState();

  const { tooltipDescription, isTooltipDisabled } = useMemo(
    function memoizeTooltipConfiguration() {
      if (!isChatEnabled && hasTwoMonthsPassedSincePracticeOpened) {
        return { tooltipDescription: CHAT_WITH_OPERATOR_CLOSED_BECAUSE_OF_TIME_TEXT, isTooltipDisabled: false };
      }
      if (!isPracticeSentToOperator) {
        return { tooltipDescription: CHAT_WITH_OPERATOR_NEED_TO_SEND_PRACTICE_TEXT, isTooltipDisabled: false };
      }

      return { tooltipDescription: EMPTY_STRING, isTooltipDisabled: true };
    },
    [isChatEnabled, isPracticeSentToOperator, hasTwoMonthsPassedSincePracticeOpened]
  );

  return { tooltipDescription, isTooltipDisabled };
}
